import React from 'react';
import {DataPoint} from "../../../services/ngage/insights";
import TimeSeriesChart from "../TimeSeriesChart";

// Types ----

type AppDownloadsChartProps = {
  data: Array<DataPoint>
  androidData?: Array<DataPoint>
  iosData?: Array<DataPoint>
}

// Component ----

function AppDownloadsChart({data, androidData, iosData}: AppDownloadsChartProps) {
  const datasets = [
    {
      label: "All Platforms",
      backgroundColor: "rgba(99, 102, 241, 0.8)",
      borderColor: "rgba(79, 70, 229, 1)",
      pointBackgroundColor: "rgba(99, 102, 241, 1)",
      data: data.map(point => point.difference)
    }
  ];

  if(androidData && androidData.length > 0) {
    datasets.push({
      label: "Android",
      backgroundColor: "rgba(82,209,74,0.8)",
      borderColor: "rgb(121,222,114, 1)",
      pointBackgroundColor: "rgba(82,209,74,1)",
      data: androidData.map(point => point.difference)
    })
  }

  if(iosData && iosData.length > 0) {
    datasets.push({
      label: "iOS",
      backgroundColor: "rgba(111,111,111,0.8)",
      borderColor: "rgb(134,134,134)",
      pointBackgroundColor: "rgba(111,111,111,1)",
      data: iosData.map(point => point.difference)
    })
  }

  return <TimeSeriesChart
    datasets={datasets}
    labels={data.map(point => point.start.toLocaleString({dateStyle: 'medium'}))}
    xAxis={'Week'}
    yAxis={'Downloads'}
  />;
}

// Export ----

export default AppDownloadsChart;